'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Retry = Retry;
/**
 * @param {number} [count] number of retries. 0 === no retries, just call
 */
function Retry() {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    count = count | 1;

    if (count < 0) {
        throw new Error('A `count` parameter should be an integer not less than 0.');
    }

    return function (target, key, descriptor) {
        var fn = descriptor.value;

        return {
            configurable: descriptor.configurable,
            enumerable: descriptor.enumerable,

            value: function value() {
                var _this = this;

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                var counter = count;
                var call = function call() {
                    return fn.apply(_this, args).catch(function (error) {
                        if (counter--) {
                            return call();
                        } else {
                            throw error;
                        }
                    });
                };
                return call();
            }
        };
    };
}
//# sourceMappingURL=data:application/json;base64,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